import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const DeleteIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.5 6.5h17M15.136 4.5H8.863A1.364 1.364 0 0 0 7.5 5.864V6.5h9v-.636A1.363 1.363 0 0 0 15.136 4.5ZM10.5 15.5v-6M13.5 15.5v-6"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.355 19.245A1.354 1.354 0 0 1 16 20.5H8a1.355 1.355 0 0 1-1.355-1.255L5.5 6.5h13l-1.145 12.745Z"
            />
        </svg>
    </IconWrapper>
)
